import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { ExclamationCircleTwoTone } from '@ant-design/icons';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { factorColorConfig } from 'pages/GradeDial/helpers/drawGradeDonut';
import Label from 'components/form/Label/Label';

export const SesameGradeBanner = props => {
  const overallCSGrade = props.overallCSGrade?.toUpperCase();
  const color = factorColorConfig[overallCSGrade?.substring(0, 1)]?.color;
  return (
    <FlexContainer className="flex-row justify-between margLR16 m-margLR0 m-margB36 m-padL16 bgWhite">
      <FlexContainer>
        <FlexContainer
          className="fontLatoNormal700 text-24 borderRadius2 justify-center items-align-center width48px height48px"
          style={{ border: `1px solid ${color}`, background: `${color}` }}
        >
          {overallCSGrade}
        </FlexContainer>
        <FlexContainer className={'margL16 items-align-center '}>
          <Label
            type="H3"
            typeHeader={'h3'}
            className={'fontLatoNormal700 text-20 margB0'}
          >
            {' '}
            Your Sesame Grade
          </Label>
        </FlexContainer>
        <CSTooltip
          className="padL4 padT8"
          tooltipContent="Your SesameGrade is calculated by Credit Sesame and is a representation of a weighted average of the primary credit factors. This grade is for educational purposes only and is not reported to any credit bureaus."
        >
          <ExclamationCircleTwoTone twoToneColor="#0070F6" />
        </CSTooltip>
      </FlexContainer>

      <FlexContainer className={'m-hide items-align-center margR40'}>
        Below offers are based on your grade.
      </FlexContainer>
    </FlexContainer>
  );
};
